export default __webpack_public_path__ + "static/media/social-media-face.32a2d52f.svg";